import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	host: { 'class' : 'd-flex flex-column align-items-center justify-content-center' }
})

export class LoginComponent implements OnInit {

	constructor(
		private oktaAuth: OktaAuthService,
        private renderer: Renderer2,
		@Inject(DOCUMENT) private document: Document,
	) { }

	ngOnInit(): void {
		this.renderer.addClass(this.document.body, 'no-padding');
	}

	ngOnDestroy(): void {
		this.renderer.removeClass(this.document.body, 'no-padding');
	}

	login() {
		this.oktaAuth.loginRedirect('/');
	}
}
